import DefaultTools from '@/components/Includes/DefaultTools/DefaultTools.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import TableEmpty from '@/components/Includes/Table/TableFooter/TableEmpty/TableEmpty.vue';
import IPayloadQuery from "@/interfaces/IPayloadQuery";
import ITableCol from '@/interfaces/ITableCol';
import ITrafficSource from '@/interfaces/ITrafficSource';
import IMultiSelectItem from "@/interfaces/selects/IMultiSelectItem";
import { extractData } from '@/libs/backend/apimapper';
import transformDateFields from "@/libs/date/transformDateFields";
import getTableColumns from "@/libs/getTableColumns";
import searchByTable from "@/libs/searchQuery/searchByTable";
import {TRAFFIC_SOURCE_CREATE} from "@/libs/userAbility/userAbilityRoles/rolesTrafficSource";
import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

@Component({
    name: 'TrafficSourcesList',
    components: {
        DefaultTools,
        TableEmpty,
        Loader
    }
})
export default class TrafficSourcesList extends Vue {
    @Action private trafficSourcesList!: (query: IPayloadQuery) => Promise<void>;

    private loading: boolean = true;

    private trafficSources: ITrafficSource[] = [];
    private selectedTableColumns: IMultiSelectItem[] = [];

    private filtered: any = null;

    private get accessTrafficSourceCreate(): string {
        return TRAFFIC_SOURCE_CREATE;
    }

    // Begin Config for Table
    private filterData(query: string) { // Method for search tool
        this.filtered = searchByTable(query, this.trafficSources)
    }

    private get tableItems(): ITrafficSource[] {
        return this.filtered ? this.filtered : this.trafficSources;
    }

    private get tableColumns(): ITableCol[] | undefined {
        if (this.tableItems) {
            return getTableColumns(this.trafficSources, true, ['id']);
        }
    };

    private get fields() {
        if (this.tableColumns) {
            const columnsIds = this.selectedTableColumns.map((el: IMultiSelectItem) => el.value);
            return this.tableColumns.filter((el: any) => columnsIds.includes(el.key));
        } else {
            return this.tableColumns;
        }
    }

    private trafficSourceDetail(trafficSource: any) {
        this.$router.push({
            name: 'traffic_source_detail',
            params: {id: trafficSource.id, trafficSourceData: trafficSource}
        });
    }

    // End Config for Table

    // Begin Transform Data for Form Campaign
    private checkDateFields(sourceData: ITrafficSource[]) {
        const dateFields: string[] = ['createdAt', 'updatedAt'];
        transformDateFields(dateFields, sourceData)
    }

    // End Transform Data for Form Campaign

    private async mounted() {
        try {
            const trafficSources = await this.trafficSourcesList({query: '?page=1&limit=300'});
            this.trafficSources = extractData(trafficSources);
            this.checkDateFields(this.trafficSources);
            this.loading = false;
        } catch {
            return void 0;
        }
    }
}
